import React from "react";
import Translate from "../../../../modules/local/Translate";

export const renderDayOfWeek = (weekdays = '') => {
  let week_label;

  switch (weekdays) {
    case '0111110':
      week_label = <Translate>{t => t('from mon to fri')}</Translate>
      break;
    case '0111111':
      week_label = <Translate>{t => t('from mon to sat')}</Translate>
      break;
    case '1111111':
      week_label = <Translate>{t => t('everyday')}</Translate>
      break;
    case '1000000':
      week_label = <Translate>{t => t('sunday')}</Translate>
      break;
    case '0000001':
      week_label = <Translate>{t => t('saturday')}</Translate>
      break;
    default:
      let week_labels = [];
      let daily_labels = [];
      const weekdaysArr = weekdays.split("").map(Number);
      if (!!weekdaysArr[0]) week_labels.push(<Translate>{t => `${t('sunday')} `}</Translate>);

      weekdaysArr.map((e, i) => {
        if (i !== 0) {
          if (Number(e) === 1) {
            daily_labels.push(i + 1);
          }
        }
      })
      if (!!daily_labels.length) {
        week_labels.push(
          <Translate>{t => {
            return `${t('day of week')} ${daily_labels.join(", ")}`
          }}</Translate>
        )
      }
      week_label = week_labels.map((e, i) => {
        return (
          <React.Fragment key={i}>
            {
              i > 0 ? <span>, </span> : null
            }
            <span key={i} className="gap-1">{e}</span>
          </React.Fragment>
        )
      })
      break
  }

  return week_label;
}